.feature {
  overflow-wrap: break-word;

  .featureTitle {
    color: var(--fg-secondary);
  }
}

.featureLink {
  color: var(--fg-primary);
  font-weight: 500;
  text-decoration: underline dotted;
  text-decoration-color: var(--fg-tertiary);
  text-underline-offset: 3px;
  transition: opacity 0.15s, text-decoration-color 0.15s;
  border-radius: 2px;

  &:hover {
    opacity: 0.8;
    text-decoration-color: currentcolor;
  }

  &:focus-visible {
    outline: 2px solid var(--fg-info);
    outline-offset: 2px;
  }
}
